<template>
  <v-container fluid>
    <!-- CONTENTS -->
    <v-row class="pa-2">
      <v-col>
        <v-sheet>
          <v-col>
            <v-tabs grow>
              <v-tab
                v-for="(section, i) in sections"
                :key="i"
              >
                {{ $t(section.text) }}
              </v-tab>
              <v-tab-item>
                <society-section />
              </v-tab-item>
              <v-tab-item>
                <edit-society-section />
              </v-tab-item>
              <v-tab-item>
                <renewal-section />
              </v-tab-item>
              <v-tab-item>
                <check-section />
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
import societySection from "./KushinaPage/SocietySection";
import editSocietySection from "./KushinaPage/EditSocietySection";
import renewalSection from "./KushinaPage/RenewalSection";
import checkSection from "./KushinaPage/CheckSection";

// Libs
const md5 = require("md5");

export default {
  components: {
    societySection,
    editSocietySection,
    renewalSection,
    checkSection,
  },
  data() {
    return {
      sections: [
        {
          text: "akito.create",
        },
        {
          text: "akito.edit",
        },
        {
          text: "akito.renewal",
        },
        {
          text: "akito.check",
        },
      ],
    };
  },
  created() {
    document.title = this.$t("akito.account") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("akito.account"));
  },
  mounted() {
    // ADMIN CHECKING
    if (md5(this.$store.state.user.aikido) != "bc4634dcd9303d59bace805e02472bcd") {
      this.$store.dispatch("disconnect");

      if (this.$router.history.current.fullPath != "/") {
        this.$router.push({ path: "/" });
      }
    }
  },
};
</script>

<style></style>
